module.exports = __webpack_public_path__ + "assets/global.9366423b.svg";